import React, { Key, ReactNode, useState } from 'react';

import {
  ChevronContainer,
  StyledChevronIcon,
  StyledCollapse,
  StyledCollapseTitle,
  StyledDivider,
} from './Collapse.styles';

interface CollapseProps {
  titleComponent: ReactNode;
  content?: ReactNode;
  defaultExpanded?: boolean;
  key?: Key;
  onHeaderClick?: () => void;
  showDivider?: boolean;
  backgroundColor?: string;
  allClickable?: boolean;
  maxHeight?: string;
  scrollable?: boolean;
  titleContainerStyles?: any;
  chevronIcon?: ReactNode;
  css?: any;
}

// The title component will be rendered as the title of the collapse and be present when collapsed.
// The content component will be rendered as the content of the collapse and be present when expanded.
const Collapse = ({
  titleComponent,
  content,
  defaultExpanded,
  onHeaderClick,
  showDivider,
  allClickable = true,
  titleContainerStyles,
  chevronIcon,
  ...props
}: CollapseProps): any => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded || false);

  const onClick = () => {
    if (!content) return;
    if (onHeaderClick) {
      onHeaderClick?.();
    } else {
      // If no custom behaviour is defined then toggle the expanded value
      setIsExpanded((prevState) => !prevState);
    }
  };

  return (
    <StyledCollapse
      {...props}
      contentLeft={
        <StyledCollapseTitle style={titleContainerStyles} onClick={onClick}>
          {titleComponent}
        </StyledCollapseTitle>
      }
      divider={false}
      preventDefault={true}
      expanded={isExpanded}
      disabled={!allClickable}
      arrowIcon={
        content ? (
          <ChevronContainer onClick={() => setIsExpanded((prevState) => !prevState)}>
            {chevronIcon ?? <StyledChevronIcon />}
          </ChevronContainer>
        ) : (
          <></>
        )
      }
      title=""
    >
      {content && (
        <>
          {showDivider && <StyledDivider />}
          {content}
        </>
      )}
    </StyledCollapse>
  );
};

export default Collapse;
